module.exports = __webpack_public_path__ + "img/management.6bd5123f.png";